import { eventBus } from "../eventbus.js";

export default {
  data: function () {
    var vm = this;
    return {
      vieweroptions:  {
        id: "viewer_wrapper",
        cb: {
            selected: function (selection) {
                var routing_params = null;
                var existing_query;
                try {
                    existing_query = vm.$route.query.p;
                } catch (err) {}

                if(selection == vm.$route.params.focus){
                    //cliccato nell'hotspot già evidenziato
                    //rimuovo la selezione
                    routing_params = { id: vm.$route.params.id }
                } else {
                    //focus hotspot
                    routing_params = { id: vm.$route.params.id, focus: selection }
                }
                
                vm.$router.push({
                    name: "wrapper_focus",
                    params: routing_params,
                    query: existing_query ? { p: existing_query } : null
                });

                if (selection) {
                    // @pointedSelection attiva la navigazione (se abilitata), la navigateTo passa anche il padre per non mandare la procedura in errore
                    // @pointedSelection intercettata sia in Detail che Image
                    vm.$root.fromViewer = true;
                    vm.$emit("pointedSelection")
                } else {
                    console.log("CALLBACK SELECTION: UNSELECTED")
                }

            },
            linked: function(link){
                var routing_params = null;
                var existing_query;
                try {
                    existing_query = vm.$route.query.p;
                } catch (err) {}

                var target = null;
                vm.activeData.children.some(function(o){
                    if(link == o[vm.$Behaviors.focusBy()]){
                        target = o.sid;
                        if(o.lin && o.gra.length>0){ //se il nodo ha lin true e c'è un disegno allegato
                            vm.$root.showOnlyImg = true;
                            vm.$root.toShow = o.gra
                        }
                        return true;
                    }
                    return false;
                })
                console.log(vm.$root.showOnlyImg)
                if(vm.$root.showOnlyImg){
                    vm.loadContentSpecial(vm.$root.toShow)
                }else{
                    console.log("target found -> " + target)
                    
                    if(target){
                        var params = {
                            source: existing_query,
                            target: target,
                            search: "id"
                        }
                        console.log("link has been triggered: ", params)

                        vm.isLoading = true;
                        vm.$root
                            .microservice({
                                role: "catalog",
                                cmd: "GetLinkPath",
                                params: params
                            }).then( response => {
                                
                                vm.isLoading = false;
                                var res = response.body;
                                try {
                                    res = JSON.parse(response.body);
                                } catch (err) {}
                                console.log(res)
                                if(res.error){
                                    eventBus.$emit('alert', {
                                        message: 'Riferimento non trovato nei figli del modello', //res.error ? res.error : 'La richiesta non è andata a buon fine',
                                        type: "error"
                                    })
                                } else if(res.path){
                                    var path = res.path.split("?")
                                    var target = path.pop();
                                    path = path.join("?")
                                
                                    vm.$root.navigateTo(target, null, null, path)
                                }
                            })
                            .catch(err => {
                                console.log(err);
                                var msg = err && err.body && err.body.error ? err.body.error : ''
                                eventBus.$emit('alert', {
                                    message: "Application caught an error <br> <h5>Details: " + "catalog.GetLinkPath - " + msg +'</h5>',
                                    type: "error",
                                    action: ''
                                })
                            });
                    } else {
                        eventBus.$emit('alert', {
                            message: 'Associazione a link non trovata nel nodo corrente', //res.error ? res.error : 'La richiesta non è andata a buon fine',
                            type: "error"
                        })
                    }
                }
            },
            detail: function(selection){
                eventBus.$emit('hotspot_tapped', selection)
            }
        },
        prefs: {
            selector: "pos",
            color: "#"+vm.$Configs.azienda.colsel,
            resizeIcon: "<i class='"+vm.$root.icons.adapt+"' aria-hidden='true' style='margin: 2px; font-size: 1.5em;'></i>",
            nocache: false
        }
      }
    }
  },
  methods: {
    loadContent: function(){
      this.reading = null;
      this.readingPage = null;
      if(this.readingDocument){
        this.readingDocument = false;
        eventBus.$emit("unloadDocument")
      }
      if(this.readingNoChildrenNode){
        this.readingNoChildrenNode = false;
        this.$root.showOnlyImg = false;
        eventBus.$emit("changeView", 'Detail');
        eventBus.$emit("defaultView", 'Detail');
        this.$root.styleSupportSidebarIcons();
      }

      if(this.activeData && this.activeData.father){
        if (this.viewerInstance == null) {
            this.viewerInstance = window.Viewer.createViewer(this.vieweroptions)
        }
        var showing = null;
        try {
            showing = this.activeData.father.gra[0].sfn
            showing = escape(showing)
        } catch(err){}
        showing = showing != null ? showing : "missing";

        var url = this.$root.getGraphic(showing, "display", false)
      
        this.viewerInstance.load({
            url: url,
            highlightTxt: this.focus,
            childNodes: this.activeData.children
        },()=>{})
      }
    },
    loadContentSpecial: function(gra){
      this.readingNoChildrenNode = true
      if(gra[0] && gra[0].sfn){
        if (this.viewerInstance == null) {
            this.viewerInstance = window.Viewer.createViewer(this.vieweroptions)
        }
        var showing = null;
        try {
            showing = gra[0].sfn
            showing = escape(showing)
        } catch(err){}
        showing = showing != null ? showing : "missing";
        var url = this.$root.getGraphic(showing, "display", false)
      
        this.viewerInstance.load({
            url: url,
            highlightTxt: null,
            childNodes: []
        },()=>{})
        
        eventBus.$emit("changeView", 'ImgLayout');
        eventBus.$emit("defaultView", 'ImgLayout');
        this.$root.styleSupportSidebarIcons();
      }                
    },
    loadDocument: function(page, from){
      this.readingDocument = true;
      if(this.reading && this.reading.filename){
          if (this.viewerInstance == null) {
              this.viewerInstance = window.Viewer.createViewer(this.options)
          }
          var showing = null;
          try {
              showing = this.getPage(this.reading.filename, page, this.reading.np)
              this.readingPage = page;
              eventBus.$emit("read_pdf_page", this.readingPage)
          } catch(err){
              console.log(err)
          }
          showing = showing != null ? showing : "missing";
          console.log(showing)
          var url = this.$root.msPath +"/"+ this.$Configs.licenseId +"/doc/pag/" + this.reading.filename + "/" + showing;
          url += ".svgz"
          var vm = this;
          this.viewerInstance.load({
              url: url,
              childNodes: []
          }, () => {
              vm.isLoading = false;
              eventBus.$emit('document_loaded') 
              if(from == 'rec-list-doc')eventBus.$emit("openSidebarDocumenti")
          })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/viewer_mixin.js